import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';

export default function Login({ handleChange,handleChangeInput,iniciarSesion,email,password,recordar, error }) {  

  const handleLogin = () => {
    iniciarSesion();
  };

  const handleKeyDownEmail = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('password-input').focus(); 
    }
  };

  const handleKeyDownPassword = (e) => {
    if (e.key === 'Enter') {
      handleLogin(); 
    }
  };  

  return (
    <>
      <Row>
        <div className='text-center mb-4' style={{ position: 'relative' }}>
          <Button
            variant="link"
            className="text-decoration-none btn-nav-log"
            style={{
              position: 'absolute',
              top: -7,
              left: 0
            }}
            onClick={() => handleChange('')}
          >
            &lt; Atrás
          </Button>
          <div className="title-login">Iniciar sesión</div>
        </div>
      </Row>
      <Form className="w-100" style={{ maxWidth: "400px" }} onSubmit={handleLogin}>
        <Form.Group>
          <Form.Control
            type="email"
            id='email'
            placeholder="Ingresa tu correo"
            className={'login-control fs-5 mb-3' + (error ? ' error' : '')}
            value={email}
            onChange={handleChangeInput}
            onKeyDown={handleKeyDownEmail} 
          />
        </Form.Group>
        <Form.Group>
          <Form.Control
            id="password" 
            type="password"
            placeholder="Ingresa tu contraseña"
            className={'login-control fs-5 mb-3' + (error ? ' error' : '')}
            value={password}
            onChange={handleChangeInput}
            onKeyDown={handleKeyDownPassword} 
          />
        </Form.Group>
        <Row className="mb-3 align-items-center">
          <Col xs="6">
            <Form.Check
              type="checkbox"
              id='recordar'
              label="Recordarme"
              checked={recordar}
              onChange={handleChangeInput}
            />
          </Col>
          <Col xs="6" className="text-end">
            <a href="#"
              className="text-decoration-none btn-a-log border-bottom fw-bold"
            >
              ¿Olvidaste tu correo?</a>
          </Col>
        </Row>
        <Button
          variant="primary"
          className="w-100 mb-3 btns-primary"
          onClick={handleLogin}
        >
          Iniciar sesión
        </Button>
      </Form>
      <div className="text-center">
        <span className='btn-a-log'>¿No tienes una cuenta? </span>
        <a
          href="#"
          className="text-decoration-none btn-a-log border-bottom fw-bold"
          onClick={() => handleChange('registrar')}
        >
          Regístrate
        </a>
      </div>
    </>
  );
}
